/**
 * Domain enums mirrored from docs/DATA_MODEL.md.
 *
 * These are declared as const objects (not TypeScript `enum`) so they survive
 * `verbatimModuleSyntax` and stay usable as plain runtime values on both the
 * server and the client.
 */
export const TokenMetadataStatus = {
    Pending: 'pending',
    Ok: 'ok',
    Failed: 'failed',
};
export const PairStatus = {
    New: 'new',
    Tracking: 'tracking',
    Ignored: 'ignored',
    Bought: 'bought',
    Error: 'error',
    /** Liquidity pulled. Terminal, and set only by the system. */
    Rugged: 'rugged',
};
export const RiskVerdict = {
    Avoid: 'avoid',
    Risky: 'risky',
    Watch: 'watch',
    Qualified: 'qualified',
};
export const TradeIntentStatus = {
    PendingApproval: 'pending_approval',
    Approved: 'approved',
    Rejected: 'rejected',
    Expired: 'expired',
    PolicyFailed: 'policy_failed',
    Executing: 'executing',
    Submitted: 'submitted',
    Confirmed: 'confirmed',
    Failed: 'failed',
};
export const TradeStatus = {
    Submitted: 'submitted',
    Confirmed: 'confirmed',
    Failed: 'failed',
};
export const ApprovalChannel = {
    Telegram: 'telegram',
    Dashboard: 'dashboard',
    Auto: 'auto',
};
export const ActorType = {
    User: 'user',
    Telegram: 'telegram',
    OpenClaw: 'openclaw',
    System: 'system',
    Worker: 'worker',
};
export const UserRole = {
    Admin: 'admin',
    Operator: 'operator',
};
/**
 * System-derived trading classification (Phase 11, ADR-056). Only `rugged`
 * and `suspected_rug` are written by any job today (Slice 11B/11C) --
 * `candidate`/`approval_eligible`/`watch`/`dead_liquidity`/`blocked`/`stale`
 * are schema-ready but not yet computed anywhere (Slice 11G's own job).
 */
export const LifecycleStatus = {
    New: 'new',
    Settling: 'settling',
    Candidate: 'candidate',
    Watch: 'watch',
    ApprovalEligible: 'approval_eligible',
    SuspectedRug: 'suspected_rug',
    Rugged: 'rugged',
    DeadLiquidity: 'dead_liquidity',
    Blocked: 'blocked',
    Stale: 'stale',
    Archived: 'archived',
};
/** System-derived read of a pair's latest liquidity reading (Phase 11, ADR-056). */
export const LiquidityStatus = {
    Unknown: 'unknown',
    Unmeasured: 'unmeasured',
    Fresh: 'fresh',
    Stale: 'stale',
    BelowMinimum: 'below_minimum',
    Dead: 'dead',
    SuspectedRug: 'suspected_rug',
    Rugged: 'rugged',
    Recovered: 'recovered',
};
/** Funding-path provenance risk level (Phase 11, Slice 11E, ADR-056/057). */
export const ProvenanceRiskLevel = {
    Unknown: 'unknown',
    Medium: 'medium',
    High: 'high',
    Critical: 'critical',
};
//# sourceMappingURL=enums.js.map